import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { ValidatorUtils } from '../../utils';
import { Routes as routes } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions } from '../../actions';
import { SwitchAccount, TitleBar, NavBar, SingleScreenNavBar, Input, Button, Errors } from  '../../components'

class PracticeFrontDeskAddEditScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      adminPassword: '',
      displayChangePW: false,
      displayChangeEmail: false,
      validation: {},
    }
  }

  renderEditFrontDeskAccount = (location, account) => {

    const accountInfo = account.user_details;

    return <div className='flex-container-column'>

        <div style={{ marginBottom: 5, fontSize: 18 }}>Front Desk for Location</div>

        <div style={{ color: 'grey', fontSize: 13 }}>{ location.name || location.street_address }</div>
        <span style={{ color: 'grey', fontSize: 13 }}>{ location.street_address }</span>
        <span style={{ color: 'grey', fontSize: 13 }}>{ location.city + ', ' + location.state + ' ' + location.zipcode }</span>

        <div style={{ marginBottom: 5, marginTop: 20, fontSize: 18 }}>Edit Front Desk Account</div>

        <div className='flex-container-column'>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 5, height: 38 }}>
            <span style={{ fontSize: 14, color: 'grey' }}>{ accountInfo.email }</span>
            <Button value="Edit"
                    className='button-clear-blue'
                    hide={this.state.displayChangeEmail}
                    style={{ paddingVertical: 5, paddingHorizontal: 5 }}
                    onClick={ () => {
                      this.setState({ ...this.state, displayChangePW: false, displayChangeEmail: true });
                    }}
                  />
          </div>

          { this.state.displayChangeEmail ? <div className='flex-container-column' style={{ alignItems: 'center' }}>
              <Input  value={this.state.email}
                      type="email"
                      placeholder="New Front Desk Email"
                      style={{ marginBottom: 10, marginRight: 20, fontSize: 15, width: '70%' }}
                      onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
              />
              <div className="flex-container flex-center-justify">
                <input  type="submit"
                        value="Cancel"
                        className="button-clear"
                        style={{ marginBottom: 10 }}
                        onClick={ () => {
                          this.setState({
                            ...this.state,
                            displayChangePW: false,
                            displayChangeEmail: false,
                          })
                        }}
                      />
                <Button value="Change Email"
                        loading={this.props.loading && this.props.loading.addEditFrontDesk}
                        style={{ marginLeft: 5, marginBottom: 10 }}
                        onClick={ () => {

                          const frontDeskUser = {
                            user_id: account.user_id,
                            practice_id: location.practice_id,
                            new_email: this.state.email,
                          }

                          if (this.state.email) {
                            this.props.practiceActions.changeFrontDeskEmail(this.props.user.auth.token, frontDeskUser, this.successAction)
                          }
                        }}
                      />
              </div>
            </div> : null }

          <div style={{ height: 1, width: '100%', backgroundColor: '#e7e7e7' }}></div>
          <div className='flex-container-row' style={{ justifyContent: 'space-between', alignItems: 'center', marginTop: 5, height: 38 }}>
            <span style={{ fontSize: 14, color: 'grey' }}>{ 'Front Desk Account Password' }</span>
            <Button value="Edit"
                    className='button-clear-blue'
                    style={{ paddingVertical: 5, paddingHorizontal: 5 }}
                    hide={this.state.displayChangePW}
                    onClick={ () => {
                      this.setState({ ...this.state, displayChangePW: true, displayChangeEmail: false });
                    }}
                  />
          </div>
        </div>

        { this.state.displayChangePW ? <div className='flex-container-column' style={{ alignItems: 'center' }}>
          <Input  value={this.state.adminPassword}
                  placeholder="Your Password"
                  type="password"
                  invalid={this.state.validation.fields && this.state.validation.fields['adminPassword']}
                  style={{ marginBottom: 10, marginRight: 20, fontSize: 15, width: '70%' }}
                  onChange={ (event) => { this.setState({ ...this.state, adminPassword: event.target.value }) }}
          />
          <Input  value={this.state.password}
                  type="password"
                  placeholder="New Front Desk Password"
                  invalid={this.state.validation.fields && this.state.validation.fields['password']}
                  style={{ marginBottom: 10, marginRight: 20, fontSize: 15, width: '70%' }}
                  onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
          />
          <Input  value={this.state.confirmPassword}
                  type="password"
                  placeholder="Confirm New Password"
                  invalid={this.state.validation.fields && this.state.validation.fields['confirmPassword']}
                  style={{ marginBottom: 20, marginRight: 20, fontSize: 15, width: '70%' }}
                  onChange={ (event) => { this.setState({ ...this.state, confirmPassword: event.target.value }) }}
          />
          <Errors validation={this.state.validation} />
          <div className="flex-container flex-center-justify">
            <input  type="submit"
                    value="Cancel"
                    className="button-clear"
                    onClick={ () => {
                      this.setState({
                        ...this.state,
                        displayChangePW: false,
                        displayChangeEmail: false,
                      })
                    }}
                  />
            <Button value="Change Password"
                    loading={this.props.loading && this.props.loading.addEditFrontDesk}
                    style={{ marginLeft: 5 }}
                    onClick={ () => {

                      const frontDeskUser = {
                        user_id: account.user_id,
                        admin_password: this.state.adminPassword,
                        password: this.state.password,
                        practice_id: location.practice_id
                      }

                      var validationInfo = Object.assign({}, frontDeskUser);
                      validationInfo.confirmPassword = this.state.confirmPassword;
                      var validation = ValidatorUtils.validate('addEditFrontDeskAccount', validationInfo);

                      if (!validation.valid) {
                        this.setState({ ...this.state, validation: validation });
                        return;
                      } else {
                        this.setState({ ...this.state, validation: validation });
                      }

                      this.props.practiceActions.changeFrontDeskPassword(this.props.user.auth.token, frontDeskUser, this.successAction)
                    }}
                  />
          </div>
        </div> : null }


    </div>
  }

  renderCreateFrontDeskAccount = (location, account) => {
    const accountExists = account ? true : false;

    return <div className='flex-container-column'>
      <div style={{ marginBottom: 5, fontSize: 18 }}>Create a new Front Desk account for</div>

      <div style={{ fontSize: 15 }}>{ location.name || location.street_address }</div>
      <span style={{ color: 'grey', fontSize: 13 }}>{ location.street_address }</span>
      <span style={{ color: 'grey', fontSize: 13 }}>{ location.city + ', ' + location.state + ' ' + location.zipcode }</span>

      <div className='flex-container-column' style={{ marginTop: 20 }}>
        <div style={{ fontSize: 18 }}>Front Desk Account Info</div>
        <span style={{ color: 'grey', fontSize: 13, marginBottom: 15 }}>Use this account info to log into the Front Desk once the account is created</span>
          <div className='flex-container-column' style={{ alignItems: 'center' }}>
            <Input  value={this.state.email}
                    placeholder="Enter Front Desk Email"
                    invalid={this.state.validation.fields && this.state.validation.fields['email']}
                    style={{ marginBottom: 10, marginRight: 20, fontSize: 15, width: '70%' }}
                    onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
            />
            <Input  value={this.state.password}
                    placeholder="Password"
                    type="password"
                    invalid={this.state.validation.fields && this.state.validation.fields['password']}
                    style={{ marginBottom: 10, marginRight: 20, fontSize: 15, width: '70%' }}
                    onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
            />
            <Input  value={this.state.confirmPassword}
                    placeholder="Confirm Password"
                    type="password"
                    invalid={this.state.validation.fields && this.state.validation.fields['confirmPassword']}
                    style={{ marginBottom: 20, marginRight: 20, fontSize: 15, width: '70%' }}
                    onChange={ (event) => { this.setState({ ...this.state, confirmPassword: event.target.value }) }}
            />
            <Errors validation={this.state.validation} />
            <div className="flex-container flex-center-justify">
              <input  type="submit"
                      value="Cancel"
                      className="button-clear"
                      onClick={ () => {
                        NavigationActions.navigateBack()
                      }}
                    />
              <Button value="Create Account"
                      loading={this.props.loading && this.props.loading.addEditFrontDesk}
                      style={{ marginRight: 5 }}
                      onClick={ () => {

                        const frontDeskUser = {
                          email: this.state.email,
                          password: this.state.password,
                          practice_id: location.practice_id,
                          practice_location_id: location._id,
                          first_name: 'Front',
                          last_name: 'Desk',
                        }

                        var validationInfo = Object.assign({}, frontDeskUser);
                        validationInfo.confirmPassword = this.state.confirmPassword;
                        var validation = ValidatorUtils.validate('addEditFrontDeskAccount', validationInfo);

                        if (!validation.valid) {
                          this.setState({ ...this.state, validation: validation });
                          return;
                        } else {
                          this.setState({ ...this.state, validation: validation });
                        }

                        this.props.practiceActions.createFrontDeskAccount(this.props.user.auth.token, frontDeskUser, this.createSuccessAction )
                      }}
                    />
            </div>


          </div>
      </div>
    </div>
  }


  renderFrontDeskAddEditSection = (location, account) => {

    if (!location) {
      return null;
    }

    const alreadyExists = account ? true: false;

    return <div className="flex-container screen-main-content">
      <div className="screen-container-column">
        <div className="basic-container">

        <div className='flex-container-column' style={{  alignItems: 'center' }}>
          <div className='flex-container-column' style={{ width: '70%' }}>
            { !alreadyExists ? this.renderCreateFrontDeskAccount(location, account) : null }
            { alreadyExists  ? this.renderEditFrontDeskAccount(location, account)   : null }
          </div>
        </div>


        </div>
      </div>
    </div>
  }

  render() {

    const frontDeskLocationId = this.props.practice && this.props.practice.selectedFrontDeskLocation ? this.props.practice.selectedFrontDeskLocation : '';
    const frontDeskLocation   = this.props.practice && this.props.practice.locations && this.props.practice.locations[frontDeskLocationId] ? this.props.practice.locations[frontDeskLocationId] : null;
    const frontDeskAccount    = this.getFrontDeskAccount(frontDeskLocation);
    const screenTitle = !frontDeskAccount ? 'Add Front Desk Account' : 'Edit Front Desk Account';

    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <SingleScreenNavBar title={screenTitle} />
        { this.renderFrontDeskAddEditSection(frontDeskLocation, frontDeskAccount) }
      </div>
    );
  }

  successAction = () => {
    this.setState({
      ...this.state,
      displayChangePW: false,
      displayChangeEmail: false,
    })
  }

  createSuccessAction = () => {
    NavigationActions.navigateBack()
  }

  getFrontDeskAccount = (location) => {
    var frontDeskAccount = null;
    var locationID = location && location._id ? location._id : '';
    var fdUsers = this.props.practice.frontDeskUsers || [];

    fdUsers.forEach((user) => {
      if (locationID && locationID === user.location_id) {
        frontDeskAccount = user;
      }
    });

    return frontDeskAccount;
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeFrontDeskAddEditScreen)
